<template>
  <div>
    <div class="container" v-if="userInfo.effective_customers == 0">
      <H1>该功能尚未开通，亲爱的小主，请耐心等待！</H1>
    </div>
    <div class="person" v-else>
      <a-skeleton :loading="loading" active :paragraph="{ rows: 8 }">
        <div class="person-container">
          <a-spin :spinning="spinning">
            <a-tabs @change="tabChange" :animated="false">
              <a-tab-pane v-for="(tab, key) in dataGroup" :key="key" class="tab-content">
                <div slot="tab">
                  {{ key | tabTitle }}
                </div>

                <div v-if="userInfo.authentication_status == '2'">
                  <a-row v-if="dataGroup[key].list.length > 0" type="flex" style="height: 100%">
                    <a-col :span="24">
                      <a-row v-if="tab && tab.list.length > 0" class="texture-list">
                        <a-col
                          :sm="12"
                          :md="8"
                          :xl="6"
                          :xxl="4"
                          v-for="(item, index) in tab.list"
                          :key="item.id">
                          <div class="texture-item">
                            <div class="cover" @click="clickItem(item)">
                              <img
                                v-if="item.cover_img"
                                :src="`${constv.QINIU_IMAGE_CND_URL}${item.cover_img}`"
                                alt=""
                              />
                              <div class="mask" v-if="item.audit_status == '0' || item.audit_status == '3'">
                                <span class="del-btn close-icon" @click.stop="showDeleteConfirm(index)"> </span>
                              </div>
                            </div>
                            <div class="sort">
                              <!-- <a-icon type="tag" rotate="270" style="color:#999999"/> -->
                              <span class="icon-icon_label_16" style="color: #bbbbbbbb"></span>
                              <span class="sort_name">人物</span>
                            </div>
                            <div class="name hide-text-1">{{ item.character_name }}</div>
                            <div class="status" :class="{ error: item.audit_status === '3' }" v-if="item.audit_status">
                              <!-- <a-tooltip
                            placement="topLeft"
                            :title="item.status == 3 ? item.status_desc : ''"
                            arrow-point-at-center
                          > -->
                              <div class="status-button">
                                <a-badge
                                  :status="statusMap[item.audit_status].status"
                                  :text="statusMap[item.audit_status].text"
                                />
                              </div>
                              <!-- </a-tooltip> -->
                              <template v-if="item.audit_status == 3">
                                <a-tooltip
                                  placement="top"
                                  :title="item.audit_status == 3 ? item.status_desc : ''"
                                  trigger="hover"
                                >
                                  <template>
                                    <span class="icon-left_help_16 errorIcon font_family"></span>
                                  </template>
                                </a-tooltip>
                              </template>
                            </div>
                          </div>
                        </a-col>
                      </a-row>
                      <div v-else class="empty-status">
                        <a-empty>
                          <span slot="description"> 没有此类型数据！ </span>
                        </a-empty>
                      </div>

                      <div v-if="tab.list.length > 0" class="pagination">
                        <a-pagination
                          :current="tab.currentPage"
                          :total="dataGroup[key].total"
                          :default-page-size="12"
                          :show-total="(total) => `共 ${Math.ceil(total / 12)} 页`"
                          @change="allPageChange"
                        />
                      </div>
                    </a-col>
                  </a-row>
                  <div v-else class="empty-status">
                    <a-empty :imageStyle="{ display: 'none' }">
                      <!-- <span
                    slot="description"
                    v-if="activeTab == 1"
                    style="font-size: 18px;color: #999999;">
                    服务器系统升级中，升级期间部分页面和功能暂停服务。已经提交成功的场景类素材包，无需重复上传，问题修复后即可正常展示。
                  </span> -->
                      <span slot="description"> 您还没有上传过任何素材，点击下方可按钮，可进行上传操作哦~ </span>
                      <a-button type="primary" style="margin-top: 24px" @click="jumpToUpload()">上传人物素材</a-button>
                    </a-empty>
                  </div>
                </div>
                <div v-else style="padding: 0 24px">
                  <div v-if="userInfo.authentication_status == '0'" class="notice">
                    认证画师后，就可以上传自己的作品喽，快来认证吧~ <br /><a-button
                      @click="goAuthor"
                      type="primary"
                      style="padding: 0 24px; margin-top: 40px"
                    >去认证</a-button
                    >
                  </div>
                  <div v-if="userInfo.authentication_status == '1'" class="notice">
                    审核同学正在疯狂审查中，我们会在三个工作日内以短信方式通知您审核结果，请耐心等待审核结果
                    <br /><a-button type="primary" style="padding: 0 24px; margin-top: 40px">审核中</a-button>
                  </div>
                  <div v-if="userInfo.authentication_status == '3'" class="notice">
                    {{ `${userInfo.authentication_status_desc}， 请重新上传` }}<br /><a-button
                      @click="goAuthor"
                      type="primary"
                      style="padding: 0 24px; margin-top: 40px"
                    >重新认证</a-button
                    >
                  </div>
                </div>
              </a-tab-pane>

              <a-dropdown slot="tabBarExtraContent" style="margin-right: 20px">
                <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                  {{ dataGroup[activeTab].activeStatus | statusMenu }}
                  <a-icon type="down" />
                </a>
                <!-- <a-menu slot="overlay" @click="statusChange">
                  <a-menu-item v-for="item in statusList" :key="item">
                    <a href="javascript:;">{{ item | statusMenu }}</a>
                  </a-menu-item>
                </a-menu> -->
              </a-dropdown>
              <a-button
                slot="tabBarExtraContent"
                type="primary"
                icon="cloud-upload"
                style="margin-right: 20px"
                :disabled="userInfo.authentication_status != '2'"
                @click="jumpToUpload()"
              >上传人物素材</a-button
              >
            </a-tabs>
          </a-spin>
          <a-modal
            v-model="showItemInfoModal"
            centered
            :footer="null"
            class="itemModal"
            :width="880"
            :bodyStyle="{ padding: '24px 8px 24px 24px' }"
          >
            <span class="close-modal-icon" slot="closeIcon"></span>
            <div slot="title" class="material-title">
              <span class="name"> 查看信息 </span>
              <div class="btn" style="margin-right: 38px">
                <a-button type="primary" @click="jumpToUpload(1)">编辑信息</a-button>
              </div>
            </div>
            <div class="package-wrapper">
              <div class="material-info">
                <div class="material-info-item">
                  <span class="label">人物名称：</span>
                  <span class="content">{{ materialInfo.character_name }}</span>
                </div>
                <div class="material-info-item">
                  <span class="label">作者名称：</span>
                  <span class="content">{{ materialInfo.author_name }}</span>
                </div>
                <div class="material-info-item">
                  <span class="label">素材简介：</span>
                  <span class="content">{{ materialInfo.brief }}</span>
                </div>
                <div class="material-info-item">
                  <span class="label">正面视角：</span>
                  <span
                    class="content"
                    v-if="materialInfo.front_view"
                  >PSD{{ materialInfo.front_view.resource_path ? '已' : '未' }}上传，预览图{{
                    materialInfo.front_view.preview_img ? '已' : '未'
                  }}上传</span
                  >
                </div>
                <div class="material-info-item">
                  <span class="label">侧面视角：</span>
                  <span
                    class="content"
                    v-if="materialInfo.side_view"
                  >PSD{{ materialInfo.side_view.resource_path ? '已' : '未' }}上传，预览图{{
                    materialInfo.side_view.preview_img ? '已' : '未'
                  }}上传</span
                  >
                </div>
                <div class="material-info-item">
                  <span class="label">背面视角：</span>
                  <span
                    class="content"
                    v-if="materialInfo.back_view"
                  >PSD{{ materialInfo.back_view.resource_path ? '已' : '未' }}上传，预览图{{
                    materialInfo.back_view.preview_img ? '已' : '未'
                  }}上传</span
                  >
                </div>
                <div class="material-info-item">
                  <span class="label">素材封面：</span>
                  <span class="content">
                    <img :src="`${constv.QINIU_IMAGE_CND_URL}${materialInfo.cover_img}`" alt="" />
                  </span>
                </div>
              </div>
            </div>
          </a-modal>
          <a-modal
            v-model="showItemModal"
            centered
            :footer="null"
            class="itemModal"
            :width="880"
            :bodyStyle="{ padding: '24px 8px 24px 24px' }"
          >
            <span class="close-modal-icon" slot="closeIcon"></span>
            <div slot="title" class="material-title">
              <span class="name"> 素材详情 </span>
              <div class="btn" style="margin-right: 38px">
                <a-button type="primary" @click="jumpToEditor">进入编辑器</a-button>
                <a-button type="primary" @click="showItemDetail" style="margin-left: 16px">查看信息</a-button>
              </div>
            </div>
            <div class="package-wrapper">
              <package-list :activeItem="activeItem"></package-list>
            </div>
          </a-modal>
        </div>
      </a-skeleton>
    </div>
  </div>
</template>

<script>
import packageList from '@/components/Zpace/packageList/packageList'
const category = {
  1: '人物'
}
const statusMap = {
  0: {
    text: '审核中',
    status: 'processing'
  },
  1: {
    text: '审核成功',
    status: 'success'
  },
  2: {
    text: '审核失败',
    status: 'error'
  }
}
export default {
  name: 'PersonManage',
  components: { packageList },
  filters: {
    statusMenu (val) {
      let text = ''
      val = val - 0
      switch (val) {
        case 0:
          text = '全部'
          break
        // case 1:
        //   text = '审核中'
        //   break
        // case 3:
        //   text = '审核失败'
        //   break
        // case 2:
        //   text = '审核成功'
        //   break
        default:
          break
      }
      return text
    },
    tabTitle (val) {
      let text = ''
      switch (val) {
        case '0':
          text = '人物'
          break
        // case '1':
        //   text = '人物'
        //   break
        // case '2':
        //   text = '贴图'
        //   break
      }

      return text
    }
  },
  data () {
    return {
      category,
      visible: false,
      statusMap,
      activeTab: '0',
      delIndex: '',
      loading: false,
      dataGroup: {
        0: {
          activeStatus: 0,
          currentPage: 1,
          pageSize: 12,
          list: [], // 显示数据
          total: [] // 当前类型的总共数据
        },
        1: {
          activeStatus: 0,
          currentPage: 1,
          pageSize: 12,
          list: [],
          total: []
        },
        2: {
          activeStatus: 0,
          currentPage: 1,
          pageSize: 12,
          list: [],
          total: []
        }
      },
      spinning: false,
      showItemModal: false,
      showItemInfoModal: false,
      activeItem: {},
      dataList: {},
      imgVisible: false,
      activeImg: '',
      materialInfo: {}
    }
  },
  computed: {
    statusList () {
      const arr = [0, 1, 2, 3]
      const index = arr.indexOf(this.dataGroup[this.activeTab].activeStatus)
      arr.splice(index, 1)
      return arr
    },
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    if (this.userInfo.authentication_status == '2' && this.userInfo.effective_customers == 1) {
      this.loadList()
    }
  },
  methods: {
    showDeleteConfirm (index) {
      this.delIndex = index
      const self = this
      this.$confirm({
        centered: true,
        content: '确定删除该素材',
        onOk () {
          self.delElement()
        },
        cancelText: '取消',
        okText: '确定',
        onCancel () {}
      })
    },
    async delElement () {
      const params = {
        id: this.dataGroup[this.activeTab].list[this.delIndex].id
      }
      await this.$api.texture.delCharacter(params)
      await this.getList()
    },
    async tabChange (e) {
      this.activeTab = e
      await this.getList()
    },
    async statusChange (e) {
      this.dataGroup[this.activeTab].activeStatus = e.key
      const dataSend = {
        page: 1
      }
      this.dataGroup[this.activeTab].currentPage = 1
      await this.getList(dataSend)
    },
    async loadList () {
      this.loading = true

      await this.getList()
      this.loading = false
    },
    async getList (params) {
      // if (this.activeTab == 1) { // 临时屏蔽场景
      //   return
      // }
      this.spinning = true
      const dataSend = {
        // category: this.activeTab,
        status: this.dataGroup[this.activeTab].activeStatus,
        page: this.dataGroup[this.activeTab].currentPage,
        pagesize: this.dataGroup[this.activeTab].pageSize
      }
      params = Object.assign(dataSend, params)
      const res = await this.$api.texture.getCharacterList({ ...params })
      this.spinning = false
      if (res.status === 'ok') {
        this.dataGroup[this.activeTab].total = res.data.count || 0
        this.dataGroup[this.activeTab].list = res.data.list || []
      }
    },
    // 分页切换
    async allPageChange (page, pageSize) {
      this.dataGroup[this.activeTab].currentPage = page
      const dataSend = {
        page,
        pagesize: pageSize
      }
      await this.getList(dataSend)
    },
    async clickItem (item) {
      this.showItemModal = true

      const res = await this.$api.texture.getCharacterInfo({ id: item.id })
      this.materialInfo = res.data
      if (res.status === 'ok') {
        this.activeItem = { res_data: [] }
        if (res.data.front_view.preview_img) { this.activeItem.res_data.push({ image: res.data.front_view.preview_img, title: '正面视角' }) }
        if (res.data.side_view.preview_img) { this.activeItem.res_data.push({ image: res.data.side_view.preview_img, title: '侧面视角' }) }
        if (res.data.back_view.preview_img) { this.activeItem.res_data.push({ image: res.data.back_view.preview_img, title: '背面视角' }) }
      }

      // } else {
      //
      // }
    },
    hide () {
      this.showItemModal = false
    },
    jumpToUpload (type = 0) {
      if (type === 0) {
        this.$router.push('/texture/personUpload')
      } else {
        this.$router.push({ path: '/texture/personUpload', query: { id: this.materialInfo.id } })
      }
    },
    jumpToEditor () {
      this.$router.push({ path: '/personEditor', query: { id: this.materialInfo.id } })
    },
    showItemDetail () {
      this.showItemInfoModal = true
    },
    goAuthor () {
      this.$router.push({
        path: '/manage/userAuthentication'
      })
    }
  }
}
</script>

<style scoped lang="less">
.container {
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.package-wrapper {
  height: 540px;
  overflow: auto;

  &::-webkit-scrollbar-track {
    background: none;
  }
  &::-webkit-scrollbar-thumb {
    background: #dddddd;
    border-radius: 4px;
  }
  .material-info {
    .material-info-item {
      font-size: 14px;
      color: #333333;
      display: flex;
      margin-bottom: 45px;
      .label {
        font-size: 14px;
        color: #333333;
        margin-right: 10px;
        width: 70px;
      }
      .content {
        flex: 1;
        margin-right: 8px;
        img {
          display: block;
          width: 120px;
          height: 120px;
          border-radius: 8px;
          border: 1px solid #f2f2f2;
        }
      }
    }
  }
}
.errorIcon {
  color: red;
  width: 16px;
  height: 16px;
  margin-left: 10px;
}
.preViewModal {
  .preViewImg {
    max-width: 620px;
  }
}

.person {
  width: 100%;
  margin: 0 auto;
  height: 100%;
  display: block;
  background-color: #ffffff;
  padding-bottom: 36px;
  min-height: 580px;
  .notice {
    min-height: 400px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    font-size: 18px;
    color: #999999;
  }
  .empty-status {
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-tabs {
    height: 100%;
  }
  .texture-list {
    display: flex;
    flex-wrap: wrap;
    min-height: 700px;
    padding-bottom: 60px;
    .texture-item {
      // margin-bottom: 8px;
      padding: 24px 30px;
      height: 334px;
      box-sizing: border-box;

      transition: ease all 0.3s;

      .cover {
        cursor: pointer;
        position: relative;
        margin-bottom: 10px;
        border: 1px solid #f2f2f2;
        display: flex;
        justify-content: center;
        align-content: center;
        width: 200px;
        height: 200px;
        border-radius: 4px;
        overflow: hidden;
        &:hover {
          .mask {
            display: block;

            .del-btn {
              display: block;
              position: absolute;
              top: 8px;
              right: 8px;
              z-index: 9;
            }
          }
        }
        .mask {
          display: none;
          position: absolute;
          border-radius: 4px;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          justify-content: flex-end;

          .del-btn {
            display: none;
            color: red;
            cursor: pointer;
          }
        }

        img {
          display: block;
          width: 100%;
          height: auto;
          object-fit: cover;
          border-radius: 4px;
        }
      }
      .sort {
        margin-bottom: 4px;
        .sort_name {
          margin-left: 5px;
          width: 24px;
          height: 11px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #bbbbbb;
          line-height: 24px;
        }
      }
      .name {
        color: #999999;
        font-size: 14px;
        margin-bottom: 10px;
      }
      .status {
        display: flex;
      }
    }
  }
}

.pagination {
  position: absolute;
  bottom: 0px;
  right: 30px;
}

.title {
  font-family: 'Quicksand', 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue',
    Arial, sans-serif;
  display: block;
  font-weight: 300;
  font-size: 100px;
  color: #35495e;
  letter-spacing: 1px;
}

.subtitle {
  font-weight: 300;
  font-size: 42px;
  color: #526488;
  word-spacing: 5px;
  padding-bottom: 15px;
}

.links {
  padding-top: 15px;
}
.itemModal {
  .material-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name {
      color: #333333;
      font-size: 16px;
    }
    .btn {
      position: absolute;
      top: 13px;
      right: 24px;
    }
  }
  .cover {
    width: 120px;
    height: 120px;
    border: 1px solid #f2f2f2;
    border-radius: 4px;
  }
  .element-list {
    display: flex;
    flex-wrap: wrap;
    .element-item {
      height: 180px;
      margin-bottom: 25px;
      &:not(:nth-of-type(5n)) {
        margin-right: 25px;
      }
      .name {
        text-align: left;
        font-size: 14px;
        color: #999999;
        margin-bottom: 24px;
        margin-top: 12px;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .cover {
        width: 142px;
        height: 142px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-radius: 4px;
        position: relative;
        &:hover {
          cursor: pointer;
          border: 1px solid @primary-color;
        }
        img {
          display: block;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
}
</style>
